import type { AuthContextValue } from '@shared/components/AuthProvider/AuthProvider.context';
import { authToUserDetails } from './authToUserDetails';
import type { EventMembership } from '@shared/components/AuthProvider';

export type UserScenario = 'unauthenticated' | 'socialLogin' | 'authenticated';

const SOCIAL_PROVIDERS = new Set(['facebook', 'google-oauth2', 'google-apps']);

const isSocialProvider = (provider: string): boolean => SOCIAL_PROVIDERS.has(provider);

const isJoyEmployee = (email: Maybe<string>): boolean => email?.endsWith('@withjoy.com') ?? false;

/**
 * Determines the user's scenario based on their authentication state.
 * - 'unauthenticated': User is not logged in
 * - 'socialLogin': User logged in via social provider, not a Joy employee, and has no owned event
 * - 'authenticated': User is logged in (regular flow)
 */
export const getUserScenario = (auth: AuthContextValue, eventMemberships: ReadonlyArray<EventMembership>): UserScenario => {
  if (!auth.isLoggedIn) {
    return 'unauthenticated';
  }

  const { profile } = auth.currentUser;

  if (!profile || !profile.activeAlias?.provider) {
    return 'authenticated';
  }

  const { ownedEventWebsite } = authToUserDetails(auth, eventMemberships);

  if (isSocialProvider(profile.activeAlias.provider) && !isJoyEmployee(profile.email) && !ownedEventWebsite) {
    return 'socialLogin';
  }

  return 'authenticated';
};
